import React, {PureComponent} from 'react';
import {
    Button
} from 'semantic-ui-react';

export default class LanguagePicker extends PureComponent {
    render(){
        const {changeLanguage} = this.props
        return (
            <li className="navigation__item__last">
                <p>
                    <Button id="en" onClick={changeLanguage}>
                        <i className="gb flag" ></i> ENGLISH 
                    </Button>
                    <Button id="ro" onClick={changeLanguage}>
                        <i className="ro flag"></i> ROMANIAN 
                    </Button>
                </p>
            </li>
        )
    }
}



// WEBPACK FOOTER //
// ./src/LanguagePicker.jsx